module.exports = __webpack_public_path__ + "static/img/marioMaffi.97338a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/marioMaffi.png
// module id = rFLA
// module chunks = 1